import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ProgramDetailComponent } from "./components/program-detail/program-detail.component";
import { FinanceModalComponent } from "./components/finance-modal/finance-modal.component";
import { ListModalComponent } from "./components/list-modal/list-modal.component";
import { TargetComponent } from "./components/target/target.component";
import { ProgramContainerComponent } from "./components/program-container/program-container.component";
import { CalculationChamberInvestigationsComponent } from "./components/calculation-chamber-investigations/calculation-chamber-investigations.component";
import { CalculationChamberDetailComponent } from "./components/calculation-chamber-detail/calculation-chamber-detail.component";
import { BudgetChangesModalComponent } from "./components/budget-changes-modal/budget-changes-modal.component";
import { MotionsComponent } from "./components/motions/motions.component";
import { LogInComponent } from "./components/log-in/log-in.component";
import { AuthService } from "./services/auth.service";
import { GeneralBudgetChangesComponent } from "./components/general-budget-changes/general-budget-changes.component";
import { AccessabilityComponent } from "./components/accessability/accessability.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    children: [],
    canActivate: [AuthService],
  },
  {
    path: "programma/:id",
    component: ProgramContainerComponent,
    canActivate: [AuthService],
    canActivateChild: [AuthService],
    children: [
      {
        path: "",
        component: ProgramDetailComponent,
        children: [],
      },
      { path: "beleidsdoel/:bid", component: TargetComponent },
      { path: "financieel", component: FinanceModalComponent },
      {
        path: "beleidskaders",
        component: ListModalComponent,
        data: { type: 1 },
      },
      { path: "moties", component: ListModalComponent, data: { type: 2 } },
      { path: "begrotingswijzigingen", component: BudgetChangesModalComponent },
    ],
  },
  {
    path: "rekenkamer",
    component: CalculationChamberInvestigationsComponent,
    canActivate: [AuthService],
  },
  {
    path: "rekenkamer/:id",
    component: CalculationChamberDetailComponent,
    canActivate: [AuthService],
  },
  { path: "moties", component: MotionsComponent, canActivate: [AuthService] },
  {
    path: "begrotingswijzigingen",
    component: GeneralBudgetChangesComponent,
    canActivate: [AuthService],
  },
  { path: "toegankelijkheid", component: AccessabilityComponent },
  { path: "login", component: LogInComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthService],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts